


































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import VehicleFormInfo from '@/modules/Vehicle/components/forms/VehicleFormInfo.vue'
import { newVehicle, editVehicle } from '@/modules/Vehicle/gql/vehicle.gql'
import { IVehicleInfoInput } from '@/modules/Vehicle/interfaces/vehicle-form'
import { Vehicle } from '@/modules/Vehicle/interfaces/vehicle'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { Case } from '@/modules/Case/interfaces/case'
import { vehicleCoverageKeys } from '@/modules/Vehicle/helpers/vehicle'
import { vehicleOwnershipOptions } from '@/modules/Vehicle/helpers/vehicle-ownership-options'
import { vehicleUseageOptions } from '@/modules/Vehicle/helpers/vehicle-useage-options'

@Component({
  components: {
    VehicleFormInfo,
    AppDialog,
    AppSteps
  }
})
export default class VehicleForm extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Vehicle }) readonly vehicle!: Vehicle
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  showDialog = false
  loading = false

  stepIndex = 0
  steps = [
    ['Information', 770, 721]
  ]

  infoInput: IVehicleInfoInput = {
    name: '',
    vin: '',
    policy: {},
    year: '',
    make: '',
    loan: false,
    model: '',
    vehicleCoverageIdx: -1,
    roadsideTowing: false,
    rentalCarCoverage: false,
    notes: '',
    ownershipIdx: -1,
    useageIdx: -1,
    mileage: ''
  }

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.vehicle
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.vehicle ? 'Save' : 'Create'
  }

  get canPost () {
    return this.stepIndex < this.steps.length - 1
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.resetStep()
      this.initInput()
    }
    this.showDialog = val
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.vehicle) {
      const {
        name, vin, policy, year, make, loan, model, vehicleCoverage, roadsideTowing, rentalCarCoverage, notes, ownership, useage, mileage
      } = this.vehicle

      this.infoInput = {
        name,
        vin,
        policy,
        year,
        make,
        loan,
        model,
        vehicleCoverageIdx: vehicleCoverageKeys.findIndex(key => key === vehicleCoverage),
        roadsideTowing,
        rentalCarCoverage,
        notes,
        ownershipIdx: vehicleOwnershipOptions.findIndex(key => key.value === ownership),
        useageIdx: vehicleUseageOptions.findIndex(primaryItem => primaryItem.value === useage),
        mileage

      }
    } else {
      this.clearForm()
    }

    if (this.policy) {
      this.infoInput.policy = {
        id: this.policy.id,
        name: this.policy.policyName
      }
    }
  }

  handleStepClick (index: number) {
    if (!this.vehicle) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.vehicle) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    if (this.stepIndex > 0) {
      this.stepIndex -= 1
    }
  }

  async handleCreate () {
    const {
      infoInput: {
        name, vin, policy,
        year, make, loan, model, vehicleCoverageIdx, roadsideTowing, rentalCarCoverage, notes, ownershipIdx, useageIdx, mileage
      },
      quote, caseInfo
    } = this

    try {
      const res = await this.$apollo.mutate({
        mutation: newVehicle,
        variables: {
          vehicleInput: {
            name,
            vin,
            year,
            make,
            loan,
            model,
            notes,
            vehicleCoverage: Number(vehicleCoverageIdx) > -1 ? vehicleCoverageKeys[vehicleCoverageIdx] : null,
            roadsideTowing,
            rentalCarCoverage,
            quoteId: quote ? +quote.id : null,
            policyId: policy.id ? +policy.id : null,
            caseId: caseInfo ? +caseInfo.id : null,
            ownership: Number(ownershipIdx) > -1 ? vehicleOwnershipOptions[ownershipIdx].value : null,
            useage: Number(useageIdx) > -1 ? vehicleUseageOptions[useageIdx].value : null,
            mileage
          }
        }
      })
      this.clearForm()
      this.onSuccess('Create the new source successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const {
      infoInput: {
        name, vin, policy: { id: policyId },
        year, make, loan, model, vehicleCoverageIdx, roadsideTowing, rentalCarCoverage, notes, ownershipIdx, useageIdx,
        mileage
      }
    } = this

    try {
      const vehicleInput = {
        name,
        vin,
        year,
        make,
        loan,
        model,
        notes,
        vehicleCoverage: Number(vehicleCoverageIdx) > -1 ? vehicleCoverageKeys[vehicleCoverageIdx] : null,
        roadsideTowing,
        rentalCarCoverage,
        quoteId: this.quote ? Number(this.quote) : null,
        policyId: this.policy && Number(this.policy.id) ? Number(this.policy.id) : null,
        caseId: this.caseInfo ? Number(this.caseInfo.id) : null,
        ownership: Number(ownershipIdx) > -1 ? vehicleOwnershipOptions[ownershipIdx].value : null,
        useage: Number(useageIdx) > -1 ? vehicleUseageOptions[useageIdx].value : null,
        mileage
      }
      const res = await this.$apollo.mutate({
        mutation: editVehicle,
        variables: {
          vehicleId: +this.vehicle.id,
          vehicleInput
        }
      })
      this.clearForm()
      this.onSuccess('Update vehicle successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  clearForm () {
    this.loading = false
    this.infoInput = {
      name: '',
      vin: '',
      policy: {},
      year: '',
      make: '',
      loan: false,
      model: '',
      vehicleCoverageIdx: -1,
      roadsideTowing: false,
      rentalCarCoverage: false,
      notes: '',
      ownershipIdx: -1,
      useageIdx: -1,
      mileage: ''
    }
  }

  @Emit('hide')
  handleHide () {
    this.$emit('input', false)
  }

  @Emit('cancel')
  handleCancel () {
    this.handleHide()
    this.clearForm()
  }

  @Emit('success')
  @Emit('hide')
  onSuccess (msg = '') {
    this.handleHide()
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
